const replaceAll = require("string.prototype.replaceall");

export const getUrlParameter = name => {
  // eslint-disable-next-line no-useless-escape
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(window.location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export const replaceUrlWithTag = string => {
  let urlRegex = /((((https?|ftp):\/\/)|www.)[^\s/$.?#].[^\s]*)/gi;
  let updatedString =
    string &&
    replaceAll(string, urlRegex, url => {
      // eslint-disable-next-line no-useless-escape
      let urlHref = url.search(/^http[s]?\:\/\//gi) === -1 ? `http://${url}` : url;
      const target = _isCurrentAppLink(urlHref) ? "_self" : "_blank";
      return `<a class="link-in-textarea" href=${urlHref} target=${target}>${url}</a>`;
    });
  return updatedString;
};

export const replaceUserMentionsWithTag = string => {
  // eslint-disable-next-line no-useless-escape
  const mentionRegex = /@\[([^\]]+?)\]\(([^\)]+?)\)/g;
  let updatedString =
    string &&
    replaceAll(string, mentionRegex, mention => {
      const display = mention.substring(mention.lastIndexOf("[") + 1, mention.lastIndexOf("]"));
      const id = mention.substring(mention.lastIndexOf("(") + 1, mention.lastIndexOf(")"));
      const href = `/view-profile/${id}`;

      return `<a class="link-in-textarea" href=${href}>${display}</a>`;
    });
  return updatedString;
};

export const replaceHashWIthHashTag = string => {
  if (!string) return "";
  const str = string.split("\n").join(" \n");
  const regexp = /(?:^|\s)(?:#)([^ !@#$%^&*(),.?":{}|<>]+)/gm;
  let updatedString =
    str &&
    replaceAll(str, regexp, url => {
      // eslint-disable-next-line no-useless-escape
      const tagWord = url.substring(url.lastIndexOf("#") + 1);
      const href = `/touchpoint?tag=${encodeURI(tagWord)}`;
      return `<a class="link-in-textarea" href=${href}>${url}</a>`;
    });
  return updatedString;
};

export const insertTags = string => {
  return replaceUrlWithTag(replaceUserMentionsWithTag(replaceHashWIthHashTag(string)));
};

export const isValidURL = string => {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
};

export const validateUrl = value => {
  return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i.test(
    value,
  );
};

const _isCurrentAppLink = url => {
  return url.startsWith(window.location.origin);
};
